<template>
  <div class="home">

    <div class="nav">
      <div class="swiper">
        <transition-group name="animate__animated" class="animate__animated" enter-active-class="animate__fadeInRight" leave-active-class="animate__fadeOutLeft">
          <div class="swiper-item" v-for="(item, index) in swiperList" :key="index" v-show="currentIndex === index">
            <img :src="item" alt="轮播图" class="animate__fadeIn" name="animate__fadeIn">
          </div>
        </transition-group>
        <div class="swiper-dots">
          <span v-for="(item, index) in swiperList" :key="index" :class="{active: currentIndex === index}" @click="changeIndex(index)"></span>
        </div>
        <div class="swiper-buttons">
          <div class="swiper-button prev" @click="prevImage">&lt;</div>
          <div class="swiper-button next" @click="nextImage">&gt;</div>
        </div>
      </div>
      <div class="nav-text">
        <transition-group name=" animate__slideInUp" class="animate__slideInUp" enter-active-class="animate__slideInUp" leave-active-class="animate__slideOutDown">
          <div :key="currentIndex">
            <h1>{{ navText[currentIndex].h1 }}</h1>
            <h3 v-html="navText[currentIndex].h3"></h3>
          </div>
        </transition-group>
      </div>
    </div>

    <div class="rcic">
      <img src="../assets/ddd444-1.png" alt="" height="100%">
    </div>

    <div class="introdeuce" :class="{'animate__animated animate__zoomIn': isIntroduceVisible}">
        <div class="introdeuce-h1">
          <h1>智行移民留学事务所</h1>
        </div>
        <div class="introdeuce-p">
          <p>智行移民留学事务所 Wingo Immigration inc.(RICI) 成立于2019年 。公司位于加拿大多伦多市，是一家从事移民服务的专业公司。公司的专业团队成员由前移民难民委员会IRB法庭主审法官、前移民局签证官、移民律师、移民顾问协会持牌移民顾问、注册会计师、前税务局审计稽查官员、国际教育留学顾问、地产投资专家等专业人士组成，为客户提供包括移民、留学、投资置业、资产管理、财税规划等方面全方位、一体化的专业服务。</p>
        </div>
    </div>

    <div class="recommend">
      <div class="recommend-box" :class="{'animate__animated animate__zoomIn': isIntroduceVisible}">
        <div class="recommend-box-left">
          <div class="recommend-box-left-text">
            <span>为什么选择</span><h2>智行移民</h2>
          </div>
          <div class="recommend-box-left-p">
            <p>智行移民留学事务所是经加拿大移民部IRCC (Immigration, Refugees and Citizenship Canada)官方认证的移民服务专业机构，我们为客户提供所有的移民服务均受加拿大法律和加拿大移民顾问协会CICC (College of Immigration and Citizenship Consultants) 监督和管理，同时我们也是加拿大专业移民顾问协会CAPIC (Canadian Association of Professional Immigration Consultants) 成员。公司的移民顾问持有加拿大移民顾问协会认证签发的加拿大移民顾问执照RCIC-IRB (全称为Regulated Canadian Immigration Consultants – Immigration and Refugee Board of Canada。根据加拿大移民及难民委员会的规定，只有持有RCIC-IRB牌照的移民顾问才具有在移民及难民委员会下辖的移民庭ID、移民上诉庭IAD、难民庭RD和难民上诉庭RAD上诉的专业法律资格)，可以在加拿大移民法规定范围内最大限度地保护申请人及上诉人的合法权益。加拿大持牌移民顾问接受过系统的移民法和难民法的学习训练，熟悉各类移民法律政策和规定、申请程序、申请表格及文件材料清单，不仅能为客户节省大量的准备时间，还能提供专业的指导服务和，确保文件材料的完整性、准确性和及时性。</p>
          </div>
        </div>
        <div class="recommend-box-right">
          <div class="recommend-box-right-item" v-for="(item, index) in recommendItems" :key="index" :class="{expanded: expandedItems[index]}" @click="toggleItem(index)">
            <div>
              <div class="recommend-box-right-item-img">
                <img :src="item.icon" alt="" width="30px" height="30px">
                <span>{{ item.title }}</span>
              </div>
              <img src="../assets/箭头.svg" alt="" width="20px" height="20px" :class="{rotated: expandedItems[index]}">
            </div>
            <div class="item-content">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
      <button class="recommend-btn" @click="$router.push('/processing-time')">IRCC各类移民签证申请审批时间表</button>
    </div>

    <div class="service">
      <div class="service-title">
        <h1>我们的服务</h1>
      </div>
      <div class="service-list" :class="{'animate__animated animate__heartBeat': isServiceVisible}" >
        <div class="service-list-item"  @click="$router.push('/immigration')">
          <img src="../assets/c1.jpg" alt="" width="80%">
          移民申请
        </div>
        <div class="service-list-item" @click="$router.push('/visa')">
          <img src="../assets/c2.jpg" alt="" width="80%">
          签证服务
        </div>
        <div class="service-list-item" @click="$router.push('/prcard')">
          <img src="../assets/b3.jpg" alt="" width="80%">
          枫叶卡及入籍
        </div>
        <div class="service-list-item"  @click="$router.push('/appeal')">
          <img src="../assets/c4.jpg" alt="" width="80%">
          移民上诉
        </div>
        <div class="service-list-item" @click="$router.push('/study')">
          <img src="../assets/c5.jpg" alt="" width="80%">
          留学服务
        </div>
      </div>
    </div>

    <div class="assess">
      <div class="assess-title">
        <h1>资格评估计分器</h1>
        <p>免费评估，欢迎留言垂询</p>
      </div>
      <div class="assess-input" :class="{'animate__animated animate__zoomIn': isAssessVisible}" >
        <div class="assess-input-left">
          <div class="assess-input-left-item" @click="$router.push('/fsw-calculator')">快速通道FSW Eligibility Criteria入池计分器</div>
          <div class="assess-input-left-item"><a href="https://www.canada.ca/en/immigration-refugees-citizenship/services/immigrate-canada/express-entry/check-score.html">快速通道EE CRS计分器</a></div>
          <div class="assess-input-left-item" @click="$router.push('/ielts-converter')">雅思G类与CLB分数转换器</div>
        </div>
        <div class="assess-input-right">
          <div class="assess-input-right-top"> 
            <div class="assess-input-right-top-inputs">
                <input type="text" placeholder="姓名" class="assess-input-right-top-input">
                <input type="text" placeholder="电子邮件" class="assess-input-right-top-input">
                <input type="text" placeholder="电话" class="assess-input-right-top-input">
                <input type="text" placeholder="微信" class="assess-input-right-top-input">
            </div>
            <div class="assess-input-right-textarea">
              <textarea name="" id="" placeholder="咨询内容"></textarea>
            </div>
          </div>
          <button class="assess-input-right-btn">提交</button>
        </div>
      </div>
    </div> 

    <div class="consult" >
      <div class="consult-img">
        <div class="consult-img-item" @click="$router.push('/news')">
          <img src="../assets/yimin.png" alt="">
          <button>更多资讯</button>
        </div>
      </div>
      <div class="consult-a">
        <ul>
          <li>IRCC对EE快速通道类别进行重大修改</li>
          <li>加拿大新的家庭护理人员移民项目即将开始实施</li>
          <li>IRCC开始实施新的规则，移民官可根据情况取消4类临时居民的签证</li>
          <li>加拿大发布实施农村和法语社区移民试点项目</li>
          <li>IRCC新规：允许超级签证申请人从加拿大以外的保险公司购买个人医疗保险</li>
          <li>2025 年加拿大各省及地区国际学生学习许可名额分配公布</li>
          <li>加拿大进一步限制国际学生和临时外籍工人的配偶获得开放工作许可 (SOWP) 的资格</li>
          <li>加拿大移民局宣布2025年不接收父母及祖父母(PGP)担保移民申请</li>
          <li>IRCC宣布取消LMIA加分，同时取消边境换签Flagpole</li>
          <li>IRCC公布对国际学生的新规定</li>
          <li>幼教工作人员及助理即将列入专科毕业生申请毕业后工签PGWP的要求专业类别中</li>
          <li>IRCC对国际学生转学实施新的政策</li>
        </ul>
      </div>
    </div>


  </div>
</template>

<script>
import 'animate.css'

export default {
  name: 'HomeView',
  data() {
    return {
      swiperList: [
        require('../assets/lb1.jpg'),
        require('../assets/lb2.jpg'),
        require('../assets/lb3.jpg'),
        require('../assets/lb4.jpg'),
        require('../assets/lb5.jpg'),
        require('../assets/lb6.jpg'),
        require('../assets/lb7.jpg'),
        require('../assets/lb8.jpg'),
      ],
      navText: [
        {id:1,h1: '智行移民，一路相伴',h3: '加拿大移民部IRCC官方认证机构，加拿大移民顾问协会CICC监管，加拿大专业移民顾问协会CAPIC成员，加拿大持牌移民顾问RCIC-IRB亲自主理。'},
        {id:2,h1: '安省雇主担保移民项目',h3: '获得省提名后提交移民申请，无需雅思！无需面试！无需打分！无资产要求！对年龄和语言没有限制，配偶和子女可以一起申请移民。'},
        {id:3,h1: '独家硕博毕业生双保险移民方案',h3:'无需工作经验，无需有雇主，毕业即可申请。在最短的时间内拿到移民身份，成功率高。'},
        {id:4,h1: '居住时间不足保枫叶卡服务',h3:'卡持卡人居住时间不足，如何在法律允许的范围内更换枫叶卡？我们的移民顾问具有丰富的移民申请经验，擅长处理各种疑难案例，即使是居住时间不足的情况下也有可能帮您成功换领枫叶卡。'},
        {id:5,h1: 'PGWP 毕业后工签',h3:'国际留学生获得加拿大移民身份的第一步，最长可拿到3年开放工签，可为任何雇主工作，一生只能申请一次。'},
        {id:6,h1: 'LMIA 工签',h3:'持工签积累加拿大工作经验，通过EE快速通道申请移民可获50分或200分的加分。配偶可获得开放工作许可Open Work Permit，不限职位和雇主。子女可免费就读加拿大公立中小学。所有家庭成员均可享受免费医疗福利。'},
        {id:7,h1: '创业移民SUV项目',h3:'无高额净资产要求，无经商管理经验要求，无资金来源证明要求，项目范围广，对申请人职业无硬性要求，允许最多5个VENTURERS共同申请，一步到位全家人一起获得移民身份。所有的项目均为B2B，没有中间环节，直接与对口的指定投资机构或孵化器企业进行衔接，保证拿到支持信，高成功率。'},
        {id:8,h1: '跨国公司员工内部派遣工签及移民项目ICT',h3:'跨国公司的企业家、高管和高级专业人员移民加拿大的最佳选择。<br>无LMIA要求，配偶及子女可同时获得工签和学签，全家人可以享受免费医疗等高福利待遇；工作一年后可申请加拿大永久居民。'},
      ],
      currentIndex: 0,
      timer: null,
      activeName: '1',
      isIntroduceVisible: false,
      isServiceVisible: false,
      isAssessVisible: false,
      expandedItems: [false, false, false],
      recommendItems: [
        {
          icon: require('../assets/赞_fill.svg'),
          title: '专业尽责',
          content: '智行移民留学事务所所有的服务均有经验丰富的持牌移民顾问亲自主理，擅长处理各种疑难案例。我们为所有的客户提供一对一的专业服务，根据每个客户的实际需求制定专属的移民方案。同时我们引入专业的移民签证文件管理系统，对所有客户的资料进行分类管理，确保所提交的全部文件准确无误并在规定的截止时间内提交。'
        },
        {
          icon: require('../assets/放大.svg'),
          title: '过程透明',
          content: '我们对所有顾客提供专业的一对一服务，所有服务均与客户签署正式的服务协议，所有的服务内容及费用均体现在服务协议条款中，我们不会在申请过程中额外增加费用，最大限度地保障客户的利益。同时，我们在客户的移民签证申请的不同阶段都与客户保持沟通和联系，使客户对申请的全过程都了如指掌、安心放心。'
        },
        {
          icon: require('../assets/锁定.svg'),
          title: '保密承诺',
          content: '我们承诺所有的专业服务都是按照加拿大的法律法规以及移民顾问监管协会的规定来进行，秉承我们的职业操守。我们在任何时候都不会提供虚假的文件和申请，同时对所有客户的资料进行保密和保存，以最高的职业标准来保护客户的隐私权益。'
        }
      ]
    }
  },
  mounted() {
    this.startTimer()
    this.observeIntroduce()
    this.observeService()
    this.observeAssess()
  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.nextImage()
      }, 6000)
    },
    stopTimer() {
      clearInterval(this.timer)
    },
    changeIndex(index) {
      this.stopTimer()
      this.currentIndex = index
      this.startTimer()
    },
    prevImage() {
      this.stopTimer()
      this.currentIndex = this.currentIndex === 0 ? this.swiperList.length - 1 : this.currentIndex - 1
      this.startTimer()
    },
    nextImage() {
      this.currentIndex = this.currentIndex === this.swiperList.length - 1 ? 0 : this.currentIndex + 1
    },
    observeIntroduce() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isIntroduceVisible = true
            observer.unobserve(entry.target)
          }
        })
      })
      observer.observe(this.$el.querySelector('.introdeuce'))
    },
    observeService() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isServiceVisible = true
            observer.unobserve(entry.target)
          }
        })
      })
      observer.observe(this.$el.querySelector('.service-list'))
    },
    toggleItem(index) {
      this.expandedItems = this.expandedItems.map((item, i) => i === index ? !item : false);
    },
    observeAssess() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isAssessVisible = true
            observer.unobserve(entry.target)
          }
        })
      })
      observer.observe(this.$el.querySelector('.assess-input'))
    }
  }
}
</script>

<style scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #fbfbfb;
}
.home .nav {
  width: 100%;
  height: 85vh;
  /* background-color: antiquewhite; */
  position: relative;
}
.swiper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.swiper-item {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.swiper-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swiper-dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}
.swiper-dots span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}
.swiper-dots span.active {
  background-color: #fff;
}
.swiper-buttons {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 50px;
  box-sizing: border-box;
}
.swiper-button {
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  border-radius: 50%;
}
.slide-enter-active, .slide-leave-active {
  transition: all 0.5s;
}
.slide-enter {
  transform: translateX(100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}
.nav-text {
  width: 80%;
  height: 100%;
  /* background-color: rgba(0, 0, 0, 0.5); */
  position: absolute;
  left: 10vw;
  top: 0;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/* Remove old transition styles */
.slide-enter-active, .slide-leave-active,
.slide-enter, .slide-leave-to {
  display: none;
}

/* Add animate.css duration override */
.animate__slideInUp {
  animation-duration: 1500ms;
}
.animate__fadeIn{
  animation-duration: 2000ms;
}
.animate__zoomIn{
  animation-duration: 2000ms;
}
.animate__heartBeat{
  animation-duration: 2000ms;
}
/* Keep other existing styles */
.rcic{
  width: 100%;
  height: 10vh;
  background-color: #55c1fd;
  display: flex;
  justify-content: center;
}
.introdeuce{
  width: 100%;
  height: 30vh;
  /* background-color: #8b979e; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.introdeuce-h1{
  width: 20%;
  height: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid red;
  color: red;
  /* background-color: antiquewhite; */
}
.introdeuce-p{
  width: 80%;
  max-width: 1200px;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666666;
  /* background-color: rgb(113, 109, 104); */
}
.recommend{
  width: 100%;
  height: 110vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background-color: #8b979e;
  background-image: url('../assets/bj1.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 40px 0; 
  box-sizing: border-box;
}
.recommend-box{
  width: 80%;
  height: 55%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
}
.recommend-box-left{
  width: 60%;
  height: 100%;
  float: left;
  /* background-color: #666666; */
  padding: 40px;
  box-sizing: border-box;
}
.recommend-box-left-text{
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid red;
  box-sizing: border-box;
  /* background-color: antiquewhite; */
  font-size: 20px;
}
.recommend-box-left-text span{
    font-size: 30px;
    margin-right: 5px;
}
.recommend-box-left-text h2{
  color: red;
}
.recommend-box-left-p{
  width: 100%;
  height: 80%;
  /* background-color: rgb(211, 173, 126); */
}
.recommend-box-right{
  width: 40%;
  height: 100%;
  float: right;
  /* background-color: #8b979e; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 50px 0;
  box-sizing: border-box;
}
.recommend-box-right-item{
  width: 80%;
  min-height: 15%;
  background-color: red;
  border: 1px solid white;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  color: white;
  padding: 15px;
  cursor: pointer;
  transition: all 1.5s ease;
  position: relative;
  overflow: visible;
}

.recommend-box-right-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.recommend-box-right-item.expanded {
  min-height: fit-content;
  height: auto;
  background-color: #cc0000;
  z-index: 10;
}

.recommend-box-right-item > div:first-child {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 5px;
}

.recommend-box-right-item img.rotated {
  transform: rotate(180deg);
  transition: transform 1.5s ease;
}

.item-content {
  margin-top: 10px;
  padding: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 14px;
  line-height: 1.6;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 1.5s ease;
  white-space: normal;
  word-wrap: break-word;
}

.recommend-box-right-item.expanded .item-content {
  opacity: 1;
  transform: translateY(0);
}

.recommend-box-right-item-img {
  width: 45%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 25px;
  font-weight: 600;
}


.recommend-btn{
  width: 25%;
  height: 10%;
  background-color: red;
  border: 2px solid white;
  border-radius: 5px;
  font-size: 20px;
  color: white;
}
.recommend-btn:hover{
  background-color: rgb(187, 187, 187);
  color: red;
  font-size: 23px;
  font-weight: 600;
}
.service{
  width: 100%;
  height: 55vh;
  /* background-color: antiquewhite; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.service-title{
  width: 20%;
  height: 20%;
  /* background-color: #8b979e; */
  border-bottom: 2px solid red;
  color: red;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.service-list{
  width: 80%;
  height: 70%;
  max-width: 1200px;
  /* background-color: #666666; */
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.service-list-item{
  width: 15%;
  height: 60%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  color: red;
  font-size: 20px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.service-list-item:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}
.assess{
  width: 100%;
  height: 70vh;
  background-color: #333333;
}
.assess-title{
  width: 100%;
  height: 20%;
  background-color: #0eb3f4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.assess-title h1{
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}
.assess-title p{
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  margin: 0;
}
.assess-input{
  width: 100%;
  height: 80%;
  max-width: 1200px;
  /* background-color: #824242; */
  margin: 0 auto;
}
.assess-input-left{
  width: 50%;
  height: 70%;
  float: left;
  /* background-color: #666666; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
.assess-input-left-item{
  width: 80%;
  height: 20%;
  background-color: #dddddd;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #000000;
}
.assess-input-left-item a{
  color: #000000;
  text-decoration: none;
}
.assess-input-left-item:hover{
  background-color: red;
  color: #ffffff;
}
.assess-input-right{
  width: 50%;
  height: 100%;
  float: right;
  /* background-color: #8b979e; */
}
.assess-input-right-top{
  width: 100%;
  height: 65%;
  /* background-color: #d28383; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.assess-input-right-top-inputs{
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}
.assess-input-right-top-input{
  width: 48%;
  height: 30%;
  /* background-color: #dddddd; */
}
.assess-input-right-top input{
  border: none;
  outline: none;
  background-color: #dddddd;
}
.assess-input-right-textarea{
  width: 98%;
  height: 49%;
  /* background-color: #d28383; */
}
.assess-input-right-textarea textarea{
  border: none;
  outline: none;
  width: 100%;
  height: 100%;
  background-color: #dddddd;
}
.assess-input-right-btn{
  width: 15%;
  height: 10%;
  background-color: red;
  border: 1px solid white;
  float: right;
  margin: 10px;
  color: white;
  font-size: 20px;
  font-weight: 600;
  border-radius: 5px;
}
.consult{
  width: 100%;
  height: 60vh;
  max-width: 1200px;
  /* background-color: #ff5d5d; */
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}
.consult-img{
  width: 50%;
  height: 100%;
  /* background-color: #666666; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.consult-img-item{
  width: 70%;
  height: 80%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}
.consult-img-item img{
  width: 90%;
}
.consult-img-item button{
  width: 40%;
  height: 15%;
  background-color: red;
  border: 1px solid white;
  color: white;
  font-size: 20px;
  font-weight: 600;
}
.consult-a{
  width: 50%;
  height: 80%;
  /* background-color: #8b979e; */
  display: flex;
  font-size: 16px;
}
.consult-a li:hover{
  color: red;
  font-weight: 600;
}

.introdeuce {
  opacity: 0;
}
.introdeuce.animate__animated {
  opacity: 1;
}
</style>
<style scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #fbfbfb;
}
.home .nav {
  width: 100%;
  height: 85vh;
  /* background-color: antiquewhite; */
  position: relative;
}
.swiper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.swiper-item {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.swiper-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swiper-dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
}
.swiper-dots span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}
.swiper-dots span.active {
  background-color: #fff;
}
.swiper-buttons {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 50px;
  box-sizing: border-box;
}
.swiper-button {
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  border-radius: 50%;
}
.slide-enter-active, .slide-leave-active {
  transition: all 0.5s;
}
.slide-enter {
  transform: translateX(100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}
.nav-text {
  width: 80%;
  height: 100%;
  /* background-color: rgba(0, 0, 0, 0.5); */
  position: absolute;
  left: 10vw;
  top: 0;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
/* Remove old transition styles */
.slide-enter-active, .slide-leave-active,
.slide-enter, .slide-leave-to {
  display: none;
}

/* Add animate.css duration override */
.animate__slideInUp {
  animation-duration: 1500ms;
}
.animate__fadeIn{
  animation-duration: 2000ms;
}
.animate__zoomIn{
  animation-duration: 2000ms;
}
.animate__heartBeat{
  animation-duration: 2000ms;
}
/* Keep other existing styles */
.rcic{
  width: 100%;
  height: 10vh;
  background-color: #55c1fd;
  display: flex;
  justify-content: center;
}
.introdeuce{
  width: 100%;
  height: 30vh;
  /* background-color: #8b979e; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.introdeuce-h1{
  width: 20%;
  height: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid red;
  color: red;
  /* background-color: antiquewhite; */
}
.introdeuce-p{
  width: 80%;
  max-width: 1200px;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666666;
  /* background-color: rgb(113, 109, 104); */
}
.recommend{
  width: 100%;
  height: 110vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background-color: #8b979e;
  background-image: url('../assets/bj1.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 40px 0; 
  box-sizing: border-box;
}
.recommend-box{
  width: 80%;
  height: 55%;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 20px;
}
.recommend-box-left{
  width: 60%;
  height: 100%;
  float: left;
  /* background-color: #666666; */
  padding: 40px;
  box-sizing: border-box;
}
.recommend-box-left-text{
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid red;
  box-sizing: border-box;
  /* background-color: antiquewhite; */
  font-size: 20px;
}
.recommend-box-left-text span{
    font-size: 30px;
    margin-right: 5px;
}
.recommend-box-left-text h2{
  color: red;
}
.recommend-box-left-p{
  width: 100%;
  height: 80%;
  /* background-color: rgb(211, 173, 126); */
}
.recommend-box-right{
  width: 40%;
  height: 100%;
  float: right;
  /* background-color: #8b979e; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 50px 0;
  box-sizing: border-box;
}
.recommend-box-right-item{
  width: 80%;
  min-height: 15%;
  background-color: red;
  border: 1px solid white;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  color: white;
  padding: 15px;
  cursor: pointer;
  transition: all 1.5s ease;
  position: relative;
  overflow: visible;
}

.recommend-box-right-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.recommend-box-right-item.expanded {
  min-height: fit-content;
  height: auto;
  background-color: #cc0000;
  z-index: 10;
}

.recommend-box-right-item > div:first-child {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 5px;
}

.recommend-box-right-item img.rotated {
  transform: rotate(180deg);
  transition: transform 1.5s ease;
}

.item-content {
  margin-top: 10px;
  padding: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 14px;
  line-height: 1.6;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 1.5s ease;
  white-space: normal;
  word-wrap: break-word;
}

.recommend-box-right-item.expanded .item-content {
  opacity: 1;
  transform: translateY(0);
}

.recommend-box-right-item-img {
  width: 45%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 25px;
  font-weight: 600;
}


.recommend-btn{
  width: 25%;
  height: 10%;
  background-color: red;
  border: 2px solid white;
  border-radius: 5px;
  font-size: 20px;
  color: white;
}
.service{
  width: 100%;
  height: 55vh;
  /* background-color: antiquewhite; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.service-title{
  width: 20%;
  height: 20%;
  /* background-color: #8b979e; */
  border-bottom: 2px solid red;
  color: red;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.service-list{
  width: 80%;
  height: 70%;
  max-width: 1200px;
  /* background-color: #666666; */
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.service-list-item{
  width: 15%;
  height: 60%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  color: red;
  font-size: 20px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.service-list-item:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}
.assess{
  width: 100%;
  height: 70vh;
  background-color: #333333;
}
.assess-title{
  width: 100%;
  height: 20%;
  background-color: #0eb3f4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.assess-title h1{
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  margin: 0;
}
.assess-title p{
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  margin: 0;
}
.assess-input{
  width: 100%;
  height: 80%;
  max-width: 1200px;
  /* background-color: #824242; */
  margin: 0 auto;
}
.assess-input-left{
  width: 50%;
  height: 70%;
  float: left;
  /* background-color: #666666; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
.assess-input-left-item{
  width: 80%;
  height: 20%;
  background-color: #dddddd;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #000000;
}
.assess-input-left-item a{
  color: #000000;
  text-decoration: none;
}
.assess-input-left-item:hover{
  background-color: red;
  color: #ffffff;
}
.assess-input-right{
  width: 50%;
  height: 100%;
  float: right;
  /* background-color: #8b979e; */
}
.assess-input-right-top{
  width: 100%;
  height: 65%;
  /* background-color: #d28383; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.assess-input-right-top-inputs{
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}
.assess-input-right-top-input{
  width: 48%;
  height: 30%;
  /* background-color: #dddddd; */
}
.assess-input-right-top input{
  border: none;
  outline: none;
  background-color: #dddddd;
}
.assess-input-right-textarea{
  width: 98%;
  height: 49%;
  /* background-color: #d28383; */
}
.assess-input-right-textarea textarea{
  border: none;
  outline: none;
  width: 100%;
  height: 100%;
  background-color: #dddddd;
}
.assess-input-right-btn{
  width: 15%;
  height: 10%;
  background-color: red;
  border: 1px solid white;
  float: right;
  margin: 10px;
  color: white;
  font-size: 20px;
  font-weight: 600;
  border-radius: 5px;
}
.consult{
  width: 100%;
  height: 60vh;
  max-width: 1200px;
  /* background-color: #ff5d5d; */
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
}
.consult-img{
  width: 50%;
  height: 100%;
  /* background-color: #666666; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.consult-img-item{
  width: 70%;
  height: 80%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}
.consult-img-item img{
  width: 90%;
}
.consult-img-item button{
  width: 40%;
  height: 15%;
  background-color: red;
  border: 1px solid white;
  color: white;
  font-size: 20px;
  font-weight: 600;
}
.consult-a{
  width: 50%;
  height: 80%;
  /* background-color: #8b979e; */
  display: flex;
  font-size: 16px;
}
.consult-a li:hover{
  color: red;
  font-weight: 600;
}

.introdeuce {
  opacity: 0;
}
.introdeuce.animate__animated {
  opacity: 1;
}
@media screen and (max-width: 768px) {
  .nav-text {
    width: 90%;
    left: 5vw;
  }
  .nav-text h1 {
    font-size: 24px;
  }
  .nav-text h3 {
    font-size: 14px;
  }
  .swiper-buttons {
    padding: 0 20px;
  }
  .swiper-button {
    width: 30px;
    height: 30px;
    font-size: 16px;
  }
  .introdeuce-h1 {
    width: 60%;
  }
  .introdeuce-p {
    width: 90%;
    font-size: 14px;
  }
  .recommend {
    height: auto;
    padding: 20px 0;
  }
  .recommend-box {
    width: 90%;
    height: auto;
  }
  .recommend-box-left,
  .recommend-box-right {
    width: 100%;
    float: none;
    padding: 20px;
  }
  .recommend-box-right-item {
    width: 90%;
    margin-bottom: 15px;
  }
  .service-title {
    width: 60%;
  }
  .service-list {
    width: 90%;
    flex-direction: column;
    height: auto;
    gap: 20px;
    padding: 20px 0;
  }
  .service-list-item {
    width: 80%;
    height: 150px;
  }
  .assess {
    height: auto;
    padding: 20px 0;
  }
  .assess-title h1 {
    font-size: 28px;
  }
  .assess-title p {
    font-size: 16px;
  }
  .assess-input {
    padding: 0 20px;
  }
  .assess-input-left,
  .assess-input-right {
    width: 100%;
    float: none;
  }
  .assess-input-left-item {
    width: 90%;
    font-size: 16px;
  }
  .assess-input-right-top-inputs {
    flex-direction: column;
    gap: 10px;
  }
  .assess-input-right-top-input {
    width: 100%;
  }
}
</style>
